var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7435 9.56374C13.7209 7.28491 15.6021 6.19135 15.6862 6.13721C14.6288 4.59053 12.9815 4.37794 12.3945 4.35403C10.9927 4.21251 9.65958 5.17984 8.94737 5.17984C8.23713 5.17984 7.13958 4.37527 5.97726 4.39656C4.44951 4.41914 3.04101 5.28514 2.25342 6.65345C0.666188 9.40728 1.84744 13.4889 3.39448 15.7219C4.1502 16.8154 5.05144 18.0439 6.23502 18C7.37442 17.9552 7.80561 17.2619 9.18387 17.2619C10.5618 17.2619 10.9488 18 12.155 17.9764C13.3814 17.9538 14.1584 16.8616 14.9091 15.7644C15.7778 14.4954 16.1339 13.2683 16.1555 13.2052C16.1283 13.1929 13.7641 12.2874 13.7402 9.56472L13.7435 9.56374H13.7435ZM11.478 2.87443C12.1058 2.11272 12.53 1.05536 12.4141 0C11.5096 0.0368719 10.4127 0.602916 9.76325 1.36364C9.18024 2.03898 8.67099 3.11527 8.8072 4.14903C9.81739 4.22778 10.8488 3.6358 11.477 2.87575L11.478 2.87443Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.48d03ce5b5979aabee987905d6814f97.svg";
export { ForwardRef as ReactComponent };